import React, {Component} from 'react';
import Resize from 'react-resize-detector';
import PropTypes from 'prop-types';

import * as d3 from 'd3';
import _ from 'lodash';

import HoverOver from '../HoverOver';
import './PercentRadial.css';

class PercentRadial extends Component {

  _currentAngle = 0;

  constructor(props) {
    super(props);

    this.state = {
      margin: {left: 10, right: 10, top: 10, bottom: 60},
      width: 500,
      height: props.height || 230
    };
  }

  componentDidMount() {
    this.handelResize();
  }

  componentDidUpdate() {
    setTimeout(this.renderD3.bind(this), 100);
  }

  handelResize() {
    const bounds = d3.select(this.refs.wrapper).node().getBoundingClientRect();
    const width = bounds.width || 100;
    const height = Math.min(width, this.props.height || 280);

    let mergedState = _.merge({}, this.state, {
      width: width,
      height: height
    });

    this.setState(mergedState);
  }

  renderD3() {
    const height = this.state.height - this.state.margin.top - this.state.margin.bottom;
    const props = this.props;
    const self = this;

    const radius = height / 2 - 4;
    const arcwidth = Math.min(26, radius / 3.3);
    const twoPi = 2 * Math.PI;

    const arc = d3.arc()
      .startAngle(0)
      .outerRadius(radius)
      .innerRadius(radius - arcwidth)
      .cornerRadius(arcwidth / 2);

    const arcTween = () => {
      const newAngle = props.value / props.total * twoPi;
      const i = d3.interpolate(this._currentAngle, newAngle);
      this._currentAngle = newAngle;
      return function (t) {
        return arc.endAngle(i(t))();
      };
    };

    const getHover = () => {
      const type = props.alternate ? 'Female' : 'Male';
      const content = (
        <div>
          <h4>{type + ' Overdose'}</h4>
          <div><b>{type + ' Deaths'}</b> : <i>{d3.format(',')(props.value)}
            &nbsp;
            <small>({d3.format('.2p')(props.value / props.total)})</small>
          </i></div>
          <div><b>Total Deaths</b> : <i>{d3.format(',')(props.total)}</i></div>
        </div>
      );

      const r = radius - arcwidth / 2 + 1,
        a = (props.value / props.total * twoPi - Math.PI / 2 - arcwidth / 2 / radius),
        x = Math.ceil(Math.cos(a) * r) + self.state.width / 2,
        y = Math.ceil(Math.sin(a) * r) + self.state.height / 2 - 17;

      return {x, y, content};
    };

    d3.select(this.refs.background)
      .attr("d", arc.endAngle(twoPi));

    d3.select(this.refs.foreground)
      .on('mouseenter', () => {
        self.setState({hover: getHover()});
      })
      .on("mouseout", () => {
        self.setState({hover: null});
      })
      .on("click", () => {
        if (props.onClick) {
          props.onClick(props.alternate ? 'Female' : 'Male');
        }
      })
      .transition()
      .attrTween("d", arcTween)
  }

  render() {
    return (
      <div ref="wrapper" className="PercentRadialChart" height={this.state.height}>
        <Resize handleWidth onResize={this.handelResize.bind(this)}/>
        <svg width={this.state.width} height={this.state.height}>
          <g transform={"translate(" + (this.state.width / 2) + "," + (this.state.height / 2 - 18) + ")"} ref="svg">
            <g className="pie-arc">
              <path ref="background" className="background"></path>
              <path
                ref="foreground"
                className="foreground"
                fill={this.props.alternate ? "#c85a5a" : "#64acbe"}
              ></path>
            </g>
            <text className="label"
                  textAnchor="middle"
                  fontSize={Math.round(this.state.height / 10)}
            >{d3.format('.0%')(this.props.value / this.props.total)}</text>
            <text className="subLabel"
                  textAnchor="middle"
                  dy={Math.round(this.state.height / 11)}
                  fontSize={Math.round(this.state.height / 14)}
            >{d3.format(',.0d')(this.props.value)}</text>
            <text className="title"
                  textAnchor="middle"
                  dy={Math.round(this.state.height / 2 - 20)}
                  fontSize={Math.round(this.state.height / 14)}
            >{this.props.title}</text>
          </g>
        </svg>
        <HoverOver data={this.state.hover}/>
      </div>
    );
  }
}

PercentRadial.propTypes = {
  value: PropTypes.number,
  total: PropTypes.number,
  onClick: PropTypes.func
};

export default PercentRadial;



// WEBPACK FOOTER //
// ./src/charts/PercentRadial/index.js